import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { SessionService } from "../app-state-services/session/session.service";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ChatService {

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {}

  startChatWithIntent(payload: any): Observable<any> {
    const url = `start_chat_with_intent`;
    return this.http.post(url, payload); 
  }

  chatWithAiAgent(payload: any): Observable<any> {
    const url = `chat`;
    return this.http.post(url, payload); 
  }

  saveHumanAgentMessageThread(payload: any): Observable<any> {
    const url = "ha/log_human_agent_interaction";
    return this.http.post(url, payload,{ responseType: 'text' });
  }

  getChannelOptions(conversationContextId: string): Observable<ChannelAvailability[]> {
    return this.http.get<ChannelAvailability[]>(`chat/channel-options`, {
      params: { conversationContextId },
    });
  }

  switchChannel(payload: {
    conversationContextId: string;
    channel: string;
    phoneNumber?: string;
  }): Observable<{ channel: string; confirmationMessage: string }> {
    return this.http.post<{ channel: string; confirmationMessage: string }>(`chat/switch-channel`, payload);
  }

  reportPresence(conversationContextId: string, online: boolean): Observable<void> {
    return this.http.post<void>(`chat/presence`, { conversationContextId, online });
  }

  reportPresenceKeepalive(conversationContextId: string, online: boolean): void {
    if (!conversationContextId) {
      return;
    }
    // pagehide/unload cannot wait for HttpClient; keepalive fetch copies interceptor tenant headers.
    const tenantCode = this.sessionService.getTenantCode();
    const workshopId = this.sessionService.getWorkshopId();
    const headers: Record<string, string> = { "Content-Type": "application/json" };
    if (tenantCode) {
      headers["X-Tenant-Code"] = tenantCode;
    }
    if (workshopId) {
      headers["X-Workshop-Id"] = workshopId;
    }
    fetch(`${environment.apiURL}chat/presence`, {
      method: "POST",
      headers,
      body: JSON.stringify({ conversationContextId, online }),
      keepalive: true,
    }).catch(() => {});
  }
}

export interface ChannelAvailability {
  channel: string;
  label: string;
  available: boolean;
  unavailableReason?: string;
  current?: boolean;
  supportsCustomerSwitch?: boolean;
  recordedMobile?: string;
}
